export default __webpack_public_path__ + "static/media/264fc6c0464ccb3c4b966516971853ae.jpg";